/**
 * The contract's `error.details[]`, and the one rule every form that renders it shares.
 *
 * `setup-app.ts`'s `exceptionFactory` emits one entry per failing property, so a rule broken by
 * several members of a collection arrives as several details carrying the **identical** string —
 * two address names failing `@Matches` (ADO 118942), two discount tiers breaching the same Step-1
 * limit (`discount.service.ts`'s LIMIT_TO_ORIGINAL loop). Joined naively, the toast reads the
 * reason out twice. Deduping is the toast's concern only: the fields still each get their own
 * `setError`, because every offending control must be marked.
 */

/** One flattened class-validator failure. */
export type ValidationDetail = { field: string; message: string };

/** Distinct messages, in first-seen order — the toast's text. */
export function dedupeMessages(details: ValidationDetail[]): string[] {
  return [...new Set(details.map((detail) => detail.message))];
}
